import { isSocialLoginUrl } from '../../app/src/features/authentication/constants/SocialAuth';
import { useConversation } from '../../conversations/src/features/detail/shared/api/getConversationById';
import { ConversationDetail } from '../../conversations/src/features/overview/types/DetailTypes';
import { useCompanyConversations } from './useCompanyScanQueries';

interface PreviousSession {
  data: ConversationDetail | undefined;
  isLoading: boolean;
}

const usePreviousSession = (
  partyId?: string | null,
  isCompleted?: boolean,
): PreviousSession => {
  if (isSocialLoginUrl) return { data: undefined, isLoading: false };

  const { data, isLoading: isLoadingConversations } = useCompanyConversations(
    partyId || '',
    isCompleted,
  );

  const lastConversation = data?.items?.[0];

  const { data: conversationDetail, isLoading: isLoadingConversationDetail } =
    useConversation(lastConversation?.id, { enabled: !!data });

  const isLoading = isLoadingConversationDetail || isLoadingConversations;

  if (conversationDetail) {
    if (!partyId) return { data: undefined, isLoading: false };

    if (data?.items && data.items.length > 0) {
      return {
        data: conversationDetail,
        isLoading,
      };
    }
  }

  return { data: undefined, isLoading };
};

export default usePreviousSession;
